import React, { useContext, useState } from 'react';
import { CrownOutlined } from '@ant-design/icons';
import './styles.less';
import { EasyDrawContext } from '@/store';
import { observer } from 'mobx-react-lite';
import Login from '@/pages/Auth/Login';
import PayModal from '@/components/PayModal';
import { useTranslation } from 'react-i18next';

export const UpgradeEntry = observer(() => {
  const store = useContext(EasyDrawContext);
  const user = store.userStore;
  const isLogin = store?.isLogin;
  const prefixCls = 'upgrade-entry';
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });

  const [loginVisible, setLoginVisible] = useState(false);
  const [paymentVisible, setPaymentVisible] = useState(false);

  const handleClick = () => {
    if (!isLogin) {
      setLoginVisible(true);
      return;
    }
    setPaymentVisible(true);
  };

  const buttonText = user?.vipLevel > 0 ? t('renew') : t('upgrade');

  return (
    <>
      <button 
        type="button"
        className={`${prefixCls}-btn`} 
        onClick={handleClick}
      >
        <CrownOutlined className="icon" />
        {buttonText}
      </button>
      <Login visible={loginVisible} onClose={() => setLoginVisible(false)} />
      <PayModal 
        visible={paymentVisible ? 'vip' : false}
        user={user}
        onClose={() => setPaymentVisible(false)}
        onSuccess={() => {
          setPaymentVisible(false);
          user?.queryUserInfo?.(true);
        }}
      />
    </>
  );
});

export default UpgradeEntry;
